import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'

Vue.use(Router)

const createInitialRouter = () => new Router({
  base: '/',
  mode: 'history',
  routes: [
  ],
  linkActiveClass: 'link-active',
  linkExactActiveClass: 'link-exact-active',
  overwriteNames: true
})

const createResetRouter = () => new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: Home,
      props: {
        type: 'home'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Home,
      props: {
        type: 'login'
      }
    }
  ],
  linkActiveClass: 'link-active',
  linkExactActiveClass: 'link-exact-active',
  overwriteNames: true
})

const router = createInitialRouter()

const resetRouter = () => {
  const newRouter = createResetRouter()
  router.matcher = newRouter.matcher
}

export {router, resetRouter}



// WEBPACK FOOTER //
// ./src/router/index.js